import request from "@/router/axios";
// 执行列表
export const getList = (params) => {
    return request({
        url: "/api/produce/safety-check-record/select/page",
        method: "post",
        data: params,
    });
};
export const exportExcel = (params) => {
    return request({
        url: "/api/produce/safety-check-record/export/excel",
        method: "post",
        data: params,
        responseType: "blob",
    });
};
// 查询检查表
export const getCheckList = (params) => {
    return request({
        url: "/api/produce/safety-check-plan/select/page",
        method: "post",
        data: params,
    });
};
export const add = (row) => {
    return request({
        url: "/api/produce/safety-check-record/insert",
        method: "post",
        data: row,
    });
};

export const updateSub = (row) => {
    return request({
        url: "/api/produce/safety-check-record-ext/update",
        method: "post",
        data: row,
    });
};
export const updateMainCheck = (row) => {
    return request({
        url: "/api/produce/safety-check-record/updateMainCheck",
        method: "post",
        data: row,
    });
};

export const getUserList = () => {
    return request({
        url: "/api/produce/blade-user/select/userList",
        method: "post",
        params: {},
    });
};

export const getDeptTree = () => {
    return request({
        url: "/api/produce/blade-dept/select/deptSelect",
        method: "get",
    });
};


export const update = (row) => {
    return request({
        url: "/api/produce/safety-check-list/update",
        method: "post",
        data: row,
    });
};
export const getDetail = (id) => {
    return request({
        url: '/api/produce/safety-check-record/getDetail/id',
        method: 'get',
        params: {
            id
        }
    })
}
// 执行检查详情
export const getCheckExecutel = (id) => {
    return request({
        url: '/api/produce/safety-check-record/checkExecute/id',
        method: 'get',
        params: {
            id
        }
    })
}
// 普通详情接口
export const getRecordDetail = (id) => {
    return request({
        url: '/api/produce/safety-check-record/getDetail/id',
        method: 'get',
        params: {
            id
        }
    })
}

// 关联整改列表
export const getTraceHazardRectifyDetail = (id) => {
    return request({
        url: '/api/produce/safety-check-record/traceHazardRectify/id',
        method: 'get',
        params: {
            id
        }
    })
}
export const remove = (id) => {
    return request({
        url: '/api/produce/safety-check-list/delete/id',
        method: 'get',
        params: {
            id
        }
    })
}

export const changeStatus = (id, type) => {
    return request({
        url: `/api/produce/safety-check-list/${type}/id`,
        method: 'post',
        params: {
            id
        }
    })
}

// 执行检查主表提交
// export const updateMainCheck = (id) => {
//     return request({
//         url: '/api/produce/safety-check-record/updateMainCheck',
//         method: 'get',
//         params: {
//             id
//         }
//     })
// }

// 通用上传（复用已有OSS附件上传接口）
export const uploadEndpoint = "/api/blade-resource/oss/endpoint/put-file-attach";
